import { createFileRoute } from '@tanstack/react-router'
import { RentalApplicationsPage } from '../../../components/rentalApplications/RentalApplicationsPage'

/** The rental applications pipeline (spec 2026-10-25-11). The listing filter lives in the URL. */
export const Route = createFileRoute('/$org/rental-applications/')({
  component: RentalApplicationsPage,
  validateSearch: (search: Record<string, unknown>) => ({
    listing: search.listing ? String(search.listing) : undefined,
  }),
})
